import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import type { Theme, ThemeOptions } from '@mui/material/styles';

function UncheckedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="3" fill="none" stroke="currentColor" strokeWidth="1" />
    </SvgIcon>
  );
}

function CheckedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="3" fill="currentColor" stroke="none" />
      <path
        d="M7.4 12.2l3.0 3.0 6.3-6.7"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

function IndeterminateIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <rect x="3" y="3" width="18" height="18" rx="3" fill="currentColor" stroke="none" />
      <path d="M7.5 12h9" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
}

export function checkboxThemeComponents(theme: Theme): ThemeOptions['components'] {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '&.SmCheckbox-formLabel--compact': {
            margin: 0,
            '& .MuiFormControlLabel-label': {
              fontSize: '0.6rem',
              marginInlineStart: theme.spacing(0.25),
              lineHeight: 1.2
            }
          }
        }
      }
    },
    MuiCheckbox: {
      defaultProps: {
        disableRipple: true,
        icon: <UncheckedIcon />,
        checkedIcon: <CheckedIcon />,
        indeterminateIcon: <IndeterminateIcon />
      },
      styleOverrides: {
        root: {
          // Unchecked border — must stay visible on tinted rows (e.g. Leads `isNew` #ececec); grey[300] blends away.
          '&.SmCheckbox-root:not(.Mui-checked):not(.MuiCheckbox-indeterminate):not(.Mui-disabled)': {
            color: theme.palette.grey?.[100] ?? '#AFBDD2'
          },
          // Ensure checked/indeterminate use the same color (avoid app-level overrides forcing black).
          '&.SmCheckbox-root.Mui-checked:not(.Mui-disabled), &.SmCheckbox-root.MuiCheckbox-indeterminate:not(.Mui-disabled)':
            {
              color: theme.palette.primary.main
            },
          '&.SmCheckbox-root--compact': {
            padding: '2px',
            '& .MuiSvgIcon-root': {
              fontSize: '0.75rem'
            }
          }
        }
      }
    }
  };
}
